import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { PaymanetInfo, PaymentDiscount, PaymentGateway, PaymentPackage } from "src/components";
import { _ } from "src/services";
import { Packages, PackagesAction } from "src/store";
import { NotFound } from "./not.found";

export const Payment: React.FC = () => {

    //#region dependencies

    const { orderId }: any = useParams();
    const dispatch = useDispatch();
    const packages: Packages = useSelector((state: any) => state.PackagesState);

    //#endregion

    //#region state

    const [bank, setBank] = useState(-1);

    //#endregion

    //#region effects

    useEffect(() => {
        dispatch(PackagesAction.requestOrderInfo(orderId));

        return () => {
            dispatch(PackagesAction.clear());
        };

    }, [dispatch, orderId]);

    useEffect(() => {

        if (packages.order?.banks.length && packages.order?.banks.every((x) => x.type !== bank)) {
            setBank(packages.order.banks[0].type);
        }

    }, [bank, packages.order?.banks]);

    //#endregion

    //#region methods

    const selectBank = (x: number) => setBank(x);

    const onPay = () => {
        const payUrl = packages.order?.payUrl;
        if (!payUrl) return;
        dispatch(PackagesAction.pay(+orderId, bank, payUrl));
    };

    //#endregion

    if (packages.order && packages.order.id < 0) return (<NotFound />);


    return (
        <div className="container program-page app-theme2 my-4 py-4">
            <h1 className="page-title text-center">{_("orderPageTitle")}</h1>

            <PaymentPackage />
            <PaymentDiscount />
            <PaymanetInfo />
            <PaymentGateway bank={bank} setBank={selectBank} />

            <button
                disabled={packages.loading}
                type="button" onClick={onPay}
                className="btn btn-packages btn-payment"
            >{_("pay")}</button>
        </div>
    );
};